import React from 'react';

import { isCliveAppClaimPage } from '~/components/ClaimPage/claimPageVariant';
import ClaimsScreenContainer from '~/components/ClaimsScreen';
import { useCms } from '~/components/hooks/useCms';

import { CliveClaimsScreen } from '../CliveApp/ClaimsScreen/CliveClaimsScreen';

/**
 * ClaimsScreenRouter - Smart routing component for claims list variants
 *
 * This component determines which claims screen variant to render based on
 * organization configuration. It uses lightweight hooks to minimize
 * performance overhead.
 *
 * Usage in CmsMainAuthenticatedInner.jsx:
 * ```
 * <SafeRoute path="/claims" component={ClaimsScreenRouter} />
 * ```
 */
export const ClaimsScreenRouter: React.FC = () => {
  const { userOrganization } = useCms();

  const isCliveAppClaimPageEnabled = isCliveAppClaimPage(userOrganization);

  return isCliveAppClaimPageEnabled ? <CliveClaimsScreen /> : <ClaimsScreenContainer />;
};
